module.exports = __webpack_public_path__ + "img/img57.fcf7ad5b.svg";